import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetNGWordsResponse } from "../../api/ng_words";
import tokenNotFound from "./config/tokenNotFound";

export type TApiNGWordsResult = {
  result?: GetNGWordsResponse[];
};

export const fetchNGWords = async (): Promise<TApiResult & TApiNGWordsResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .ng_words.get(authHeader)
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchNGWords");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
